webpackJsonp([13,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _shared = __webpack_require__(10);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _formValidator = __webpack_require__(24);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	var _applicationServices = __webpack_require__(499);
	
	var _applicationServices2 = _interopRequireDefault(_applicationServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Styles
	__webpack_require__(769); /**
	                                                 * Created by jv on 24/04/2018.
	                                                 */
	
	
	$(function () {
	  _shared2.default.shouldSetUpCreditsDialog = false;
	  _shared2.default.init();
	
	  ContactPage.init();
	});
	
	var ContactPage = {};
	
	(function (ContactPage) {
	  var contactFormValidator = null;
	
	  ContactPage.init = function () {
	    setUpEventListeners();
	  };
	
	  function setUpEventListeners() {
	    contactFormValidator = new _formValidator2.default({
	      selector: "#contact-form",
	      validateOnChange: true,
	      rules: {
	        name: { required: true },
	        email: { required: true },
	        message: { required: true }
	      }
	    });
	
	    $("#contact-submit-btn").on("click", function (e) {
	      var $this = $(this);
	      var isValid = contactFormValidator.validate();
	
	      if (isValid) {
	        $this.prop("disabled", true).removeClass("loading").addClass("loading");
	
	        var formData = contactFormValidator.getFormData();
	
	        sendContactForm(formData.name, formData.email, formData.message).then(function (data) {
	          $this.prop("disabled", false).removeClass("loading");
	
	          _shared2.default.Dialog.showMessageDialog({
	            title: "contact.submit.success.dialog.title",
	            message: "contact.submit.success.dialog.message",
	            disposable: false,
	            onConfirm: function onConfirm() {
	              contactFormValidator.clearForm();
	              _utils2.default.redirect("/home");
	            }
	          });
	        }).catch(function (err) {
	          $this.prop("disabled", false).removeClass("loading");
	
	          _shared2.default.Dialog.showMessageDialog({
	            title: err.readableErrorTitle,
	            message: err.readableErrorMessage
	          });
	        });
	      }
	    });
	  }
	
	  function sendContactForm(name, email, message) {
	    return _applicationServices2.default.sendContactForm(name, email, message, _languageManager2.default.getCurrentLocale());
	  }
	})(ContactPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Created by jv on 09/05/2017.
	 */
	var utils = __webpack_require__(3);
	var request = __webpack_require__(186);
	var log = __webpack_require__(5)();
	
	var ApplicationServices = {};
	
	(function (ApplicationServices) {
	  ApplicationServices.sendContactForm = function (name, email, message, locale) {
	    return request.post({
	      url: utils.getServiceUrl("/misc/contact"),
	      cache: false,
	      dataType: request.DATA_TYPES.JSON,
	      data: {
	        name: name,
	        email: email,
	        message: message,
	        locale: locale
	      }
	    });
	  };
	})(ApplicationServices);
	
	module.exports = ApplicationServices;

/***/ }),

/***/ 769:
47

});


// WEBPACK FOOTER //
// js/marketing/contact.c2092b9e01bc499f2d7c.js